module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gc-Hc-Ib.adef88bf.png";